import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';
import { ContainerTypeLegacy, CreateBargeForm, navigateTo, useAuth } from '@amber-ui/core';

function CreateBargeRoute() {
  const { acct } = useSearch({ strict: false }) as { acct?: string };
  const { account_id: session_account_id } = useAuth();
  const effectiveAccountId = acct || session_account_id || '';

  const onCreateSuccess = useCallback(
    // oxlint-disable-next-line typescript/no-explicit-any -- FormWrapper onSubmitSuccess receives BargeFragmentFragment
    (result: any) => {
      navigateTo('/barge/dashboard', {
        container_name: result.barge_name,
        container_id: result.barge_id,
        container_type: ContainerTypeLegacy.barge,
      });
    },
    []
  );

  return <CreateBargeForm account_id={effectiveAccountId} onSubmitSuccess={onCreateSuccess} />;
}

export const Route = createFileRoute('/_auth/_barge/barge/create')({
  component: CreateBargeRoute,
});
